import React from 'react';
import {IThemeService} from './theme.service.interface';
import {OrbitTheme} from '../../themes/architecture/orbit-theme.interface';
import {action, observable} from 'mobx';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ServiceBase} from '../ServiceBase';
import {IThemeDefinition} from "./theme-definition.interface";
import {SDK_CSS_OVERRIDE} from "../../themes/css-global-classes";


export class ThemeService extends ServiceBase implements IThemeService {

    constructor(services: IServiceFactoryExtended, theme: IThemeDefinition) {
        super(services);
        this._setCurrentTheme(theme);
        this.services.dom.body.classList.add(SDK_CSS_OVERRIDE)
    }

    @observable.ref
    private _currentThemeDefinition: IThemeDefinition | null;


    get currentTheme(): OrbitTheme | null {
        return this._currentThemeDefinition?.shellTheme;
    }

    get mainContentTheme(): OrbitTheme {
        return this._currentThemeDefinition.mainContentTheme;
    }

    get shouldUseSquareIcons(): boolean {
        return this.services.device.hybrid.isEmbedded || Boolean(this._currentThemeDefinition.useSquareIconsForGames);
    }

    get supportBadgeOnSquareIcons(): boolean {
        return Boolean(this._currentThemeDefinition.supportBadgeOnSquareIcons);
    }

    @action.bound
    private _setCurrentTheme(themeDefinition: IThemeDefinition) {
        this._currentThemeDefinition = themeDefinition;
    }

    renderGlobalStyles(): React.ReactNode {
        return this.currentTheme.globalStyles;
    }

}

